<template>
  <vs-sidebar
    position-right
    parent="body"
    default-index="1"
    color="primary"
    :class="['sidebar-base', size ? `add-new-data-sidebar-${size}` : '']"
    spacer
    v-model="active"
  >
    <div class="w-full px-2">
      <slot name="body"></slot>
    </div>

    <slot name="bodyNoPadding"></slot>

    <div
      class="flex flex-wrap items-center justify-center p-2"
      slot="footer"
    ></div>
  </vs-sidebar>
</template>

<script>
export default {
  name: "v-side",
  props: {
    title: String,
    active: Boolean,
    textSucces: String,
    size: String,
    icon: String,
    disabled: Boolean,
    item: Object,
    visualizar: false
  },
  data () {
    return {}
  },
  methods: {
    hide () {
      this.$emit("hide")
    }
  },
  components: {}
};
</script>

<style lang="scss" scoped>
.sidebar-base {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;
      .con-img-upload {
        padding: 0;
      }
      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.add-new-data-sidebar-small {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;
  }
}

.add-new-data-sidebar-large {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 700px;
    max-width: 90vw;
  }
}

.add-new-data-sidebar-huge {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1000px;
    max-width: 100vw;
  }
}

.add-new-data-sidebar-huger {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1300px;
    max-width: 100vw;
  }
}

.add-new-data-sidebar-huger-up-size {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 1350px;
    max-width: 100vw;
  }
}

</style>